export default {
	meta: {
		title: 'Les questionnaires expérience patient',
		description: 'Les questionnaires expérience patient'
	},
	question: 'Question',
	outof: 'sur',
	expiredLink: 'Votre lien n’est plus valide',
	confirmedMsg: 'Vos réponses ont bien été enregistrées, nous vous remercions de votre participation.',
	incompleteMsg: 'Il manque des réponses, nous vous prions de bien remplir le questionnaire dans son intégralité afin de pouvoir le prendre en compte.'
};
